
        var result = require("!!../../../node_modules/css-loader/index.js!./news.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/news/news.component.css
// module id = 464
// module chunks = 2